import React from "react";
import Banner from "../Components/Banner";

const policies = [
  {
    title: "1. Introduction",
    text: "This Refund and Cancellation Policy outlines the terms under which HNH Soft Tech Solutions Pvt Ltd provides refunds or accepts project cancellations for digital services.",
  },
  {
    title: "2. Nature of Services",
    text: "All services provided by HNH Soft Tech Solutions Pvt Ltd are custom digital services including website development, mobile application development, UI/UX design, and digital marketing solutions.",
  },
  {
    title: "3. Project-Based Work",
    text: "Due to the custom nature of software development services, refunds are generally not available once development work has started or project deliverables have been shared with the client.",
  },
  {
    title: "4. Milestone Payments",
    text: "Many projects are divided into milestones. If a project is cancelled before a milestone begins, a partial refund may be considered depending on the work already completed.",
  },
  {
    title: "5. Consultation Services",
    text: "Consultation or hourly technical services are non-refundable once the consultation session has been completed.",
  },
  {
    title: "6. Client Responsibilities",
    text: "Clients are responsible for providing accurate project requirements and timely feedback. Delays caused by missing client input may affect refund eligibility.",
  },
  {
    title: "7. Cancellation Requests",
    text: "Cancellation requests must be submitted in writing via email. Each request will be reviewed based on the current stage of the project.",
  },
  {
    title: "8. Processing Refunds",
    text: "If a refund is approved, it will be processed using the original payment method within a reasonable timeframe.",
  },
  {
    title: "9. Policy Updates",
    text: "HNH Soft Tech Solutions Pvt Ltd reserves the right to update or modify this Refund Policy at any time. Updates will be published on this page.",
  },
  {
    title: "10. Contact Information",
    text: "For refund or cancellation inquiries, please contact us at info@hnhsofttechsolutions.com.",
  },
];

const RefundPolicy = () => {
  return (
    <>
      <Banner
        heading="Refund, Return & Cancellation Policy"
        text="Refund Policy"
      />

      <div className="bg-[#0b1e3a] py-16 px-4">
        <div className="max-w-5xl mx-auto space-y-6">
          {policies.map((item, index) => (
            <div
              key={index}
              className="bg-[#0f2b52] border border-blue-400/30 rounded-2xl p-6 shadow-md"
            >
              <h3 className="text-white text-xl font-semibold mb-2">
                {item.title}
              </h3>
              <p className="text-gray-200 leading-relaxed">
                {item.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default RefundPolicy;